import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Model } from "survey-core";
    import { SurveyComponent } from "survey-vue3-ui";
    import "./index.css";
    import { json } from "./json";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

    const survey = new Model(json);
    survey.onComplete.add((sender, options) => {
        console.log(JSON.stringify(sender.data, null, 3));
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SurveyComponent), { model: _unref(survey) }, null, 8, ["model"]))
}
}

})